import routerUtils from "@/router/routerUtils";
import BestaetigungFH2024 from "@/views/fh2024/views/BestaetigungFH2024.vue";
import AbschlussFH2024 from "@/views/fh2024/views/AbschlussFH2024.vue";
import HistorieFH2024 from "@/views/fh2024/views/HistorieFH2024.vue";
import IhreDatenFH2024 from "@/views/fh2024/views/IhreDatenFH2024.vue";
import TarifFH2024 from "@/views/fh2024/views/TarifFH2024.vue";
import ImmobilienDetailsFH2024 from "@/views/fh2024/views/ImmobilienDetailsFH2024.vue";
import BasisdatenFH2024 from "@/views/fh2024/views/BasisdatenFH2024.vue";

const { pruefeDatenVorhanden } = routerUtils();

export default [
  {
    path: "",
    name: "FH2024_Basisdaten_MaklerLink",
    component: BasisdatenFH2024,
    props: { isMakler: true, isMaklerLink: true },
    meta: {
      title: "Ferienhauskonzept - Basisdaten | GEV-Versicherung",
    },
  },
  {
    path: "immobiliendetails",
    name: "FH2024_ImmobilienDetails_MaklerLink",
    component: ImmobilienDetailsFH2024,
    props: { isMakler: true, isMaklerLink: true },
    meta: {
      title: "Ferienhausversicherung - Immobilien-Details | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/makler-tarifrechner/fh", "NEU"),
  },
  {
    path: "tarif",
    name: "FH2024_Tarif_MaklerLink",
    component: TarifFH2024,
    props: { isMakler: true, isMaklerLink: true },
    meta: {
      title: "Ferienhausversicherung - Tarif | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/makler-tarifrechner/fh", "NEU"),
  },
  {
    path: "ihre-daten",
    name: "FH2024_IhreDaten_MaklerLink",
    component: IhreDatenFH2024,
    props: { isMakler: true, isMaklerLink: true },
    meta: {
      title: "Ferienhausversicherung - Ihre Daten | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/makler-tarifrechner/fh", "NEU"),
  },
  {
    path: "historie",
    name: "FH2024_Historie_MaklerLink",
    component: HistorieFH2024,
    props: { isMakler: true, isMaklerLink: true },
    meta: {
      title: "Ferienhausversicherung - Ihre Daten | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/makler-tarifrechner/fh", "NEU"),
  },
  {
    path: "abschluss",
    name: "FH2024_Abschluss_MaklerLink",
    component: AbschlussFH2024,
    props: { isMakler: true, isMaklerLink: true },
    meta: {
      title: "Ferienhausversicherung - Zusammenfassung und Abschluss | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/makler-tarifrechner/fh", "NEU"),
  },
  {
    path: "bestaetigung",
    name: "FH2024_Besataetigung_MaklerLink",
    component: BestaetigungFH2024,
    props: { isMakler: true, isMaklerLink: true },
    meta: {
      title: "Ferienhausversicherung - Vielen Dank | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/makler-tarifrechner/fh"),
  },
];
